module.exports = __webpack_public_path__ + "src/app/_content/BMWFonts/BMWTypeNextPro-Bold.woff?77a33ef9578330ff0dff0cec80e1e65e";